'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import Link from 'components/ui/Link';
import Text from 'components/ui/Text';

import useScrollDirection from 'hooks/useScrollDirection';

import styles from '../FAQ.module.scss';

const Menu = ({ currentCategory, categories }) => {
    const refSticky = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const scrollDirection = useScrollDirection();

    const intersection = useIntersection(refSticky, {
        rootMargin: '0px',
        threshold: 1,
    });

    useEffect(() => {
        if (intersection && intersection.intersectionRatio < 1) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    }, [intersection]);

    const handleOpenClick = () => {
        setIsOpen(true);
    };

    const handleCloseClick = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (scrollDirection === 'down' || scrollDirection === 'up') {
            isOpen && setIsOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollDirection]);
    return (
        <nav
            ref={refSticky}
            className={cx(styles.sideNav, {
                [styles.isOpen]: isOpen,
                [styles.isSticky]: isSticky,
                [styles.isFlushTop]: scrollDirection === 'down',
            })}
        >
            <div className={styles.sideNavAbsInner}>
                <div
                    className={styles.sideNavAbsInnerBack}
                    onClick={handleCloseClick}
                />
                <div className={styles.sideNavHeader} onClick={handleOpenClick}>
                    {currentCategory && (
                        <Text
                            as="span"
                            baseTheme="labelLarge"
                            className={styles.label}
                        >
                            {currentCategory.title}
                        </Text>
                    )}
                    <ButtonCircle
                        as="span"
                        className={styles.openButton}
                        onClick={handleCloseClick}
                        theme="small-fill-creamdark"
                        iconType="chevronDown"
                    />
                </div>
                <div className={styles.sideNavInner}>
                    {categories.map((category, i) => {
                        return (
                            <div
                                className={cx(styles.sideNavGroup, {
                                    [styles.isActive]:
                                        category.slug === currentCategory.slug,
                                })}
                                key={i}
                            >
                                <Text
                                    as="span"
                                    baseTheme="labelLarge"
                                    className={styles.label}
                                >
                                    <Link href={`/faq/${category.slug}`}>
                                        {category.title}
                                    </Link>
                                    {category.slug === currentCategory.slug && (
                                        <ButtonCircle
                                            as="span"
                                            className={styles.navCaret}
                                            theme="small-fill-creamdark"
                                            iconType="chevronRight"
                                        />
                                    )}
                                </Text>
                            </div>
                        );
                    })}
                    <ButtonCircle
                        as="span"
                        className={styles.closeButton}
                        onClick={handleCloseClick}
                        theme="small-fill-creamdark"
                        iconType="chevronDown"
                    />
                </div>
            </div>
        </nav>
    );
};

Menu.propTypes = {
    categories: PropTypes.shape({
        map: PropTypes.func,
    }),
    currentCategory: PropTypes.shape({
        slug: PropTypes.any,
        title: PropTypes.any,
    }),
};

export default Menu;
